<template>
  <div id="site-shell">
    <router-view />
  </div>
</template>
